export default "__VITE_ASSET__BKwROks7__"